export const selectLanes = (state) => state.lane?.lanes || [];
export const selectDriveStartTime = (state) => state.lane?.driveStartTime || null;
export const selectLanesStatus = (state) => state.lane?.lanesStatus;
export const selectLanesError = (state) => state.lane?.lanesError;

export const selectSelectedLane = (state) => state.lane?.selectedLane;

export const selectSubmitStatus = (state) => state.lane?.submitStatus;
export const selectSubmitError = (state) => state.lane?.submitError;
export const selectSubmitResult = (state) => state.lane?.submitResult;
